export default import.meta.ROLLDOWN_FILE_URL_U6muqRGa8aHtq8t0c9wAzg